'use client'

import { Fragment, useEffect, useMemo, useState } from 'react'
import { useSearchParams } from 'next/navigation'
import algoliasearch from 'algoliasearch/lite'
import {
  Hits,
  InstantSearch,
  RefinementList,
} from 'react-instantsearch-hooks-web'
import { Container } from '@cerifi/ui/components/container'
import { useBodyCss } from '@cerifi/ui/hooks/use-body-css'

import { SEARCH_INDEX_NAME } from '../search-model'
import { SearchBar } from './search-bar'
import { Hit } from './search-hit'
import { SearchPagination } from './search-pagination'
import { Stats } from './search-stats'

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID as string,
  process.env.NEXT_PUBLIC_ALGOLIA_API_KEY as string
)

export const SearchPage = () => {
  useBodyCss('bg-backgroundShade-50')
  const params = useSearchParams()

  const [query, setQuery] = useState(params?.get('term') || '')

  const uiState = useMemo(() => {
    const state: any = {}
    state[SEARCH_INDEX_NAME as string] = {
      query: query,
    }
    return state
  }, [query])

  useEffect(() => {
    setQuery(params?.get('term') || '')
  }, [params])

  return (
    <Fragment key={query}>
      <InstantSearch
        searchClient={searchClient}
        indexName={SEARCH_INDEX_NAME}
        initialUiState={uiState}
      >
        <div className="bg-white py-6">
          <Container>
            <SearchBar />

            {
              <div className="my-6">
                <RefinementList
                  sortBy={['name:asc']}
                  attribute="type"
                  classNames={{
                    list: 'flex gap-3 flex-wrap',
                    label:
                      'h-[2.625rem] rounded-full flex items-center px-6 cursor-pointer w-full justify-center',
                    checkbox: 'w-0 h-0',
                    item: 'min-w-[9.375rem] border-2 [&:not(.ais-RefinementList-item--selected)]:border-neutral-500 rounded-full focus-within:outline outline-offset-2 hover:bg-neutral-100 transition-colors outline-neutral-500',
                    selectedItem: 'border-black underline',
                    count:
                      "ml-2 text-xs no-underline before:content-['('] after:content-[')'] hidden",
                  }}
                />
              </div>
            }
          </Container>
        </div>

        <Container>
          <div className="my-6">
            <Stats />
            <Hits hitComponent={Hit} />
            <SearchPagination />
          </div>
        </Container>
      </InstantSearch>
    </Fragment>
  )
}
